import React from "react";
import { Form, Row, Col } from "antd";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledTextArea from "../../components/ControlledTextArea";

const ServiceRequestForm = ({ control, watch, errors }) => {
  return (
    <Form colon={false}>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledInput
            required
            control={control}
            name="email"
            label="Email Id"
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledInput
            required
            control={control}
            name="subject"
            label="Subject"
            errors={errors}
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <ControlledTextArea
            required
            control={control}
            name="message"
            label="Message"
            errors={errors}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default ServiceRequestForm;
